export default "__VITE_ASSET__DoyxITUq__"